"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultSalary = getDefaultSalary;
exports.hasFixedWorkDays = hasFixedWorkDays;
exports.getNominalWeeklyHours = getNominalWeeklyHours;
exports.getSalaryOrDefault = getSalaryOrDefault;
exports.isActiveOn = isActiveOn;
const openapi_1 = require("@pentacode/openapi");
const model_1 = require("./model");
function getDefaultSalary(salaries) {
    return salaries.find((s) => s.positionId === null);
}
function hasFixedWorkDays(mode) {
    return [model_1.NominalHoursMode.FixedDays, model_1.NominalHoursMode.FixedDaysWithoutHolidays].includes(mode);
}
function getNominalWeeklyHours(props) {
    var _a;
    return hasFixedWorkDays(props.nominalHoursMode)
        ? ((_a = props.hoursPerDay) === null || _a === void 0 ? void 0 : _a.reduce((total, day) => (0, openapi_1.add)(total, day), 0)) || 0
        : props.hoursPerWeek || 0;
}
function getSalaryOrDefault(positionId, salaries) {
    // Try to find position-specific salary first
    return (salaries.find((salary) => salary.positionId === positionId) ||
        // Otherwise choose default salary (no position attached)
        getDefaultSalary(salaries));
}
function isActiveOn(date, range) {
    return range.start <= date && (!range.end || range.end > date);
}
//# sourceMappingURL=contract.util.js.map